import React from 'react';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Services from './components/Services/Services';
import WhyChooseUs from './components/WhyChooseUs/WhyChooseUs';
import Gallery from './components/Gallery/Gallery';
import Reviews from './components/Reviews/Reviews';
import Contact from './components/Contact/Contact';
import styles from './App.module.css';

function App() {
  return (
    <div className={styles.app}>
      <Header />
      <Hero />
      <div id="services">
        <Services />
      </div>
      <div id="about">
        <WhyChooseUs />
      </div>
      <div id="gallery">
        <Gallery />
      </div>
      <div id="reviews">
        <Reviews />
      </div>
      <div id="contact">
        <Contact />
      </div>
    </div>
  );
}

export default App;